import Profile from "../../slices/users/profile/Profile";
import User from "../../slices/users/user/User";

const usersReducer = {
    profile: Profile,
    user: User,
};

export default usersReducer;